import createIcon from '../../icons/createIcon';

const IconCheckCircleFilled = createIcon('IconCheckCircleFilled', '0 0 32 32', [
    [
        'path',
        {
            'fill-rule': 'evenodd',
            'clip-rule': 'evenodd',
            d: 'M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28ZM22.2208 12.6931L22.9139 11.9723L21.4723 10.5861L20.7792 11.3069L13.8048 18.5602L10.2181 14.8596L9.52209 14.1415L8.08596 15.5335L8.78193 16.2515L13.0896 20.696C13.2785 20.8908 13.5384 21.0005 13.8097 21C14.081 20.9995 14.3405 20.8887 14.5285 20.6931L22.2208 12.6931Z',
            fill: '#191B21',
            key: '44b9f0'
        },
        []
    ]
]);

export { IconCheckCircleFilled };
